// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {1842: "1ff2fda115c867dca7ca",6318: "19b26f107d4cd95aade6",8746: "a00a16b28ab3ffd95bd7",}[chunkId] + ".chunk.css"
}